module.exports = "pegasus_template/assets/themelp1/health/102.png";